import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/styles/main.scss";

import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Selections from "@/components/Selections";
import Schedule from "@/components/Schedule";
import Tickets from "@/components/Tickets";
import Shop from "@/components/Shop";
import Gallery from "@/components/Gallery";
import Sponsors from "@/components/Sponsors";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";

// ── Single-page layout (all sections scroll) ──────────────────────────────
function HomePage() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <About />
        <Selections />
        <Schedule />
        <Tickets />
        <Shop />
        <Gallery />
        <Sponsors />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        {/* All section anchors resolve to home page */}
        <Route path="*" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
}
